import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { OemService } from '../../../../core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Content } from '../../../oem-portal/interface/oem-portal-interface.i';
import { Utils } from '../../../../../app/common/utils/utils';
import { first } from 'rxjs/internal/operators/first';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants';
import { environment } from '../../../../../../src/environments/environment';

@Component({
  selector: 'iposcen-approved-partner-content-view',
  templateUrl: './approved-partner-content-view.component.html',
  styleUrls: ['./approved-partner-content-view.component.scss']
})
export class ApprovedPartnerContentViewComponent implements OnInit {
  @Input() contentID: string
  @Input() autoID: string;
  @Output() readonly config = new EventEmitter();
  @Output() readonly viewOn = new EventEmitter();
  @Output() readonly selectButton = new EventEmitter();
  @Output() readonly checkStatus = new EventEmitter();
  @Output() readonly contentsData = new EventEmitter();
  contentData: any;
  contents: Content[];
  systemModelData: string;
  parsedData: any;
  singleData: boolean;
  languages: any;
  language = new Map();
  languageList = [];
  image: any;
  displayLanguage: string;
  displayName: any;
  displayLanguageList = new Map();
  displayValueList = new Map();
  contentName: string;
  systemID: string;
  languageCategory: string;
  reviewStatus: string;
  displayVal = [];
  displayLang: any;
  displayList = [];
  private ngUnsubscribe = new Subject();
  assetID: string;
  configurations: any;
  englishLang = 'English - United States';
  chineseSimplified = 'Chinese - Simplified';
  chineseTraditional = 'Chinese - Traditional';
  disvalue: string;
  comments: string;
  hasComments: boolean = false;
  hasPagesData = false;
  contentGroupPages = [];
  imageUrl: string;
  partnerId: any;
  page: number;
  globalSortValue: string;
  globalSortBy: string;
  operatingSystem: any;

  constructor(private router: Router, private oemservice: OemService) { }

  ngOnInit(): void {
    this.getContentData();
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.page = 1;
  }

  getContentData() {
    this.oemservice.getContentDatabyContentID(this.autoID, this.contentID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllContentResponse => {
        this.contentData = getAllContentResponse.content as Content[];
        this.contentName = this.contentData.contentName;
        this.systemID = this.contentData.systemID;
        this.languageCategory = this.contentData.languageCategory;
        this.reviewStatus = this.contentData.reviewStatus;
        this.configurations = JSON.parse(this.contentData.configurations);
        this.contentGroupPages.push(this.configurations.contentGroupPages);
        this.autoID = this.contentData.autoID;
        this.comments = this.contentData.comments;
        this.partnerId = this.contentData.partnerID;
        this.operatingSystem = getAllContentResponse.content.operatingSystem.replaceAll(',', ', ');
        if (this.comments && this.comments !== ' ') {
          this.hasComments = true;
        } else {
          this.hasComments = false;
        }
        this.assetID = this.configurations.assetID;
        this.imageUrl = environment.apiBaseUrlAsset + OemConstants.SKU_COMMON + OemConstants.SLASH + this.autoID
          + OemConstants.SLASH_ASSETS +
          OemConstants.SLASH_THUMBNAIL + OemConstants.SLASH + this.assetID;
        this.getThumnailByAutoId();
        this.hasPagesData = true;

        try {
          this.displayName = JSON.parse(getAllContentResponse.content.displayName);
          Object.keys(this.displayName).forEach((value, index) => {
            let arr;
            this.displayLanguageList.set(index, this.getLanguageByCode(value));
            arr = Array.from(this.displayLanguageList.values());
            this.displayLang = arr;
          })
          Object.values(this.displayName).forEach((value, index) => {
            let arr;
            this.displayValueList.set(index, value);
            arr = Array.from(this.displayValueList.values());
            this.displayVal = arr;
          });
        } catch {
          this.disvalue = getAllContentResponse.content.displayName;
        }
        this.languages = getAllContentResponse.content.languages;
        try {
          this.languages = JSON.parse(this.languages);
          this.languages.forEach((data, index) => {
            this.language.set(index, this.getLanguageByCodeIn(data));
          })
          this.languageList = Array.from(this.language.values());
          this.displayLanguage = this.languageList.join(', ');
        } catch {
          this.displayLanguage = getAllContentResponse.content.languages;
        }
        this.systemModelData = getAllContentResponse.content.systemModels;
        try {
          this.parsedData = JSON.parse(this.systemModelData);
          this.singleData = false;
        } catch {
          this.parsedData = getAllContentResponse.content.systemModels;
          this.singleData = true;
        }
      })
  }
  getLanguageByCode(langCode) {
    return Utils.decodeLanguageByCodeout(langCode);
  }
  getLanguageByCodeIn(langCode){
    if(langCode === 'zh-cn'){
      return this.chineseSimplified
    } else if(langCode === 'zh-tw'){
      return this.chineseTraditional
    } else{
      return Utils.decodeLanguageByCodeIn(langCode)
    }
   
  }

  getThumnailByAutoId() {
    const reader = new FileReader();
    this.oemservice.getAssetByAutoIdAndAssetIdView(this.assetID, OemConstants.SLASH_THUMBNAIL, this.autoID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(imageData => {

        reader.addEventListener('load', () => {
        }, false);
        if (imageData) {
          reader.readAsDataURL(imageData);
        }
      },
        error => {
          // do something
        });
  }


  goBackToApprove() {
    this.getReviewData(this.partnerId, OemConstants.APPROVED_STATUS);
  }

  // To get Table data when navigate to review-partner
  getReviewData(partnerId, status) {
    this.oemservice.getContentDataUsingPartnerID(this.globalSortBy, this.globalSortValue, this.page, partnerId, status)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getApprovedPartnerResponse => {
        this.contents = getApprovedPartnerResponse;
        this.selectButton.emit(getApprovedPartnerResponse.partnerName[0]);
        this.checkStatus.emit(true);
        this.contentsData.emit(this.contents);
        this.viewOn.emit(false);
      });
  }


}
